import axios from 'axios';
import { getApiHostname } from './getApiHostname';

const api = axios.create({
  baseURL: `${getApiHostname(
    window.location.hostname
  )}/insurance/coverage-checkup`,
});

export { api };
